import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import MessageBodyAndSettingsContainer from "Components/MkMessaging/messageBodyAndSettingsContainer";
import 'Styles/MkMessaging/newMessageContainer.scss';
import MkMessagingStore from 'Stores/mkMessaging/mkMessagingStore';
import SelectUsersModal from "Components/MkMessaging/selectUsersModal";
import { Link, Navigate } from "react-router-dom";
import LoadView from "Components/Common/loadView";
import { ShowModal } from 'Utils/CommonFunctions';
import AppStore from 'Stores/AppStore';
import TransitionBlocker from 'Components/Common/TransitionBlocker';

class NewMessage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Информирование пользователей', 'newMessage', this.ReloadData);

        this.ReloadData();
    }

    componentWillUnmount() {
        MkMessagingStore.ClearNewMessageInfo();
    }

    ReloadData() {
        MkMessagingStore.ClearNewMessageInfo();
        MkMessagingStore.LoadUsersToSelect();
    }

    ShowSelectUserModal() {
        MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds = MkMessagingStore.newMessageSelectedUsersIds.map(it => it);
        ShowModal({
            canBeClosed: true,
            getHeader: () => `Выбор адресатов сообщения ${(MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.length > 0 ? `(${MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.length})` : '')}`,
            children: <SelectUsersModal />,
            className: 'mk-messaging-select-user-modal',
            buttons: [{
                content: 'Отменить',
                closer: true
            }, {
                content: 'Выбрать всех',
                onClick: action(_ =>
                    MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds = Object.keys(MkMessagingStore.usersNamesByIdsDict)
                )
            }, {
                content: 'Отменить всех',
                onClick: action(_ =>
                    MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds = []
                )
            }, {
                content: 'Сохранить',
                className: 'blue-button',
                onClick: action(_ =>
                    MkMessagingStore.newMessageSelectedUsersIds = MkMessagingStore.newMessageSelectingUsersModalSelectedUsersIds.map(it => it)
                ),
                closer: true
            }]
        });
    }

    render() {
        if (MkMessagingStore.navigateFromMessageDetails)
            return <Navigate to='../mkMessageList' />

        return (
            <div className='mk-messaging-new-message-container'>
                <TransitionBlocker
                    blocked={() => MkMessagingStore.newMessageHasChanges}
                    title='У вас есть несохраненные изменения. Если вы покинете страницу, все изменения будут утеряны.' />
                <div className='mk-messaging-new-message-container-header'>
                    Создание нового информационного сообщения
                </div>
                <div className='mk-messaging-new-message-container-body'>
                    <MessageBodyAndSettingsContainer />
                    <div className='mk-messaging-user-list-container'>
                        <div className='mk-messaging-user-list-header'>
                            {`Пользователи ${(MkMessagingStore.newMessageSelectedUsersIds.length > 0 ? `(${MkMessagingStore.newMessageSelectedUsersIds.length})` : '')}`}
                        </div>
                        <div className='mk-messaging-user-list overflowing-element'>
                            {MkMessagingStore.GetSelectedUsersByIds(MkMessagingStore.newMessageSelectedUsersIds).map((user) => (
                                <div className='mk-messaging-user'
                                    key={user.id}>
                                    <div className='user-name-container'>
                                        {user.userName}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button className='blue-button'
                            onClick={this.ShowSelectUserModal.bind(this)}>
                            Изменить список
                        </button>
                    </div>

                </div>
                <div className='mk-messaging-new-message-container-buttons-container'>
                    <Link to='../mkMessageList'>
                        <button onClick={MkMessagingStore.ClearNewMessageInfo.bind(MkMessagingStore)}>
                            Отменить
                        </button>
                    </Link>
                    <button
                        className={`blue-button ${(
                            MkMessagingStore.messageTitle.trim().length === 0 ||
                            MkMessagingStore.newMessageSelectedUsersIds.length === 0)
                            ? 'disabled' : ''}`}
                        onClick={MkMessagingStore.SendMessage.bind(MkMessagingStore)}>
                        отправить
                    </button>
                </div>
                {(MkMessagingStore.newMessageCreationInProcess) ? <LoadView modal={true} /> : ''}
            </div>
        )
    }
}

export default observer(NewMessage);